var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-modal', {
    attrs: {
      "color-overlay": "#b979e533",
      "content-position": _vm.contentPosition
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "slot": "content-wrapper"
    },
    slot: "content-wrapper"
  }, [_c('div', {
    ref: "scrollContent",
    staticClass: "modal-content"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('you.want.turn.off.self.employed')))]), _c('p', {
    staticClass: "modal-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('restrictions.after.turn.off.self.employed'))
    }
  }), _c('div', {
    staticClass: "modal-button-container"
  }, [_c('button', {
    staticClass: "modal-button success",
    on: {
      "click": _vm.handleUnbind
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.yes')) + " ")]), _c('button', {
    staticClass: "modal-button cancel",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }